import styled from "@emotion/styled";

export const IndexContainer = styled.div`
  display: flex;
  width: 120px;
  box-sizing: border-box;
  padding: 10px 16px 10px 20px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-bottom: 1px solid var(--alias-color-line-normal);
  background-color: var(--component-color-fill-alternative);
`;

export const ItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const RowsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const RowContainer = styled.div`
  display: flex;
  padding: 8px 0px;
  align-items: center;
  gap: 60px;
  box-sizing: border-box;

  border-bottom: 1px solid var(--alias-color-line-normal);

  .pageName {
    display: flex;
    width: 120px;
    padding: 0px 10px;
    align-items: center;
  }

  .checkContainer {
    display: flex;
    align-items: center;
    gap: 40px;
  }
`;

export const CheckContainer = styled.div`
  display: flex;
  width: 80px;
  padding: 10px;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
`;

export const TableRowContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: scroll;

  ::-webkit-scrollbar-thumb {
    background-color: var(--alias-color-line-normal);
    position: absolute;
    width: 6px;
    border-radius: 3px;
  }

  ::-webkit-scrollbar {
    background-color: white;
    width: 6px;
  }
`;
